module.exports = __webpack_public_path__ + "static/media/cyberscam.10da6fa4.png";